// Port of api/fuel/app/classes/controller/api/monty/groups/add.php
import DB from 'offline/db'
import Constants from 'offline/constants'
import User from 'offline/model/user'
import { currentUser, ensureMembership, groupPayload, invalid, persist, recountGroupUsers, recountUserGroups, resolveGroup, touchGroup } from './shared'

export default function(params) {
	var sessionUser = currentUser(params)
	var group = resolveGroup(params)
	if (!sessionUser || !group) return invalid(Constants.API_ERROR_UNAUTHORISED)
	if (sessionUser.get_id() !== group.get_user_id()) return invalid(Constants.API_ERROR_UNAUTHORISED)
	if (group.get_type() !== Constants.GROUP_TYPE_STANDARD) return invalid(Constants.API_ERROR_UNAUTHORISED)

	var username = String(params.user || '').toLowerCase()
	var target = User.with('user_name', username)
	if (!target || !target.has_synchronised()) return invalid(Constants.API_ERROR_USER_NOTFOUND)

	var existing = DB.query('SELECT link_id FROM link_group_user WHERE group_id = ? AND user_id = ?', [group.get_id(), target.get_id()])
	if (existing.length) return invalid(Constants.API_ERROR_USER_INGROUP)

	ensureMembership(group.get_id(), target.get_id())
	touchGroup(group.get_id())
	recountGroupUsers(group.get_id())
	recountUserGroups(target.get_id())

	return persist({
		group: groupPayload(group.get_id())
	})
}
